/**
 * Sends a post request to the server with the provided data and token.
 * @param {Object} dataTestimonial - The data to be sent in the request body.
 * @param {string} token - The authorization token.
 * @returns {Promise} - The response from the server or an error object if the request fails.
 */
import axios from 'axios';

export const dataTestimonial = async (dataTestimonial, token) => {
  const data = JSON.stringify(dataTestimonial);
  const url = `${process.env.REACT_APP_ADMIN_API_URL}/testimonials`;

  try {
    const response = await axios.post(url, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error('Error submitting testimonial:', error);
    throw error;
  }
};
